// extracted by mini-css-extract-plugin
export var mainOverlay = "Layout-module--mainOverlay--hGH--";